import WorkTypeForm from './WorkTypeForm';

export {
  WorkTypeForm
}



// WEBPACK FOOTER //
// ./src/components/admin/WorkTypes/index.js